export const CUSTOM_ICONS = [
  {
    svg: 'spinmachine',
    path: '../assets/game-icons/Slot-Machine.svg',
  },
  { svg: 'quiz', path: '../assets/game-icons/Sports-Soccer.svg' },
  { svg: 'jackpot', path: '../assets/game-icons/Diamond.svg' },
  { svg: 'board', path: '../assets/game-icons/dice.svg' },
  {
    svg: 'wheel',
    path: '../assets/game-icons/Wheel-of-Fortune.svg',
  },
  { svg: 'multiwheel', path: '../assets/game-icons/Multi-Wheel.svg' },
  { svg: 'streaks', path: '../assets/game-icons/Streaks.svg' },
  { svg: 'hub', path: '../assets/game-icons/Lobby.svg' },
  { svg: 'color-drop', path: '../assets/common-icons/drop.svg' },
  { svg: 'splash-edit', path: '../assets/common-icons/Edit.svg' },
  { svg: 'splash-lock', path: '../assets/common-icons/Lock.svg' },
];
